import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { uid } from 'react-uid';

const IFrameHTMLComponent = ({ id, name, width, height, html, onLoad }) => {
	const frameId = useRef(id || uid(name));
	useEffect(() => {
		const setIFrameContent = (content) => {
			const iFrame = document.getElementById(frameId.current);
			const iframeDocument = iFrame.contentWindow.document;
			if (iframeDocument) {
				iframeDocument.open();
				iframeDocument.write(content);
				iframeDocument.close();
			}
		};
		if (html) {
			setIFrameContent(html);
		}
	}, [html, frameId]);
	return (
		<iframe
			id={frameId.current}
			title={frameId.current}
			width={width}
			height={height}
			onLoad={onLoad}
		/>
	);
};

IFrameHTMLComponent.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	width: PropTypes.number,
	height: PropTypes.number,
	html: PropTypes.string,
	onLoad: PropTypes.string,
};

export default IFrameHTMLComponent;
